import {
  DocumentColumnWidths,
  useDocumentTableColumns,
} from '../../../../../hooks/useDocumentTableColumns';

const LIBRARY_COLUMN_WIDTHS: DocumentColumnWidths = {
  code: '100px',
  title: '382px',
  type: '250px',
  owner: '150px',
  tags: '300px',
  version: '120px',
};

export const useLibraryTableColumns = () =>
  useDocumentTableColumns({
    basePath: '/library',
    widths: LIBRARY_COLUMN_WIDTHS,
  });
